module.exports = __webpack_public_path__ + "static/img/step-08.c8cf1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-08.png
// module id = T7We
// module chunks = 1